export default {
  scale: [
    {
      id: "B1",
      price: "$21.99",
      tinyTitle: "Smart Digital Weight Scale",
      image: "/product/B0000001/main.jpg"
    },
    {
      id: "B2",
      price: "$14.99",
      tinyTitle: "Smart Digital Weight Scale",
      image: "/product/B0000002/main.jpg"
    },
    {
      id: "B3",
      price: "$19.88",
      tinyTitle: "Smart Digital Weight Scale",
      image: "/product/B0000003/main.jpg"
    },
    {
      id: "B4",
      price: "$32.99",
      tinyTitle: "Smart Digital Weight Scale",
      image: "/product/B0000004/main.jpg"
    }
  ],
  bloodPressureMonitor: [
    {
      id: "B5",
      price: "$38.99",
      tinyTitle: "Blood Pressure Monitor",
      image: "/product/B0000005/main.jpg"
    },
    {
      id: "B6",
      price: "£27.99",
      tinyTitle: "Blood Pressure Monitor",
      image: "/product/B0000006/main.jpg"
    }
  ]
};
